import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BffUserService } from '@canvas/four-r-digital';
import { of } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'finance-pwa-top-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarComponent {
  @Input() title = environment.appShortName;

  readonly userName$ = environment.useFakeLogin
    ? of('Nick Hughes')
    : this.bffUserService.userName;

  constructor(private readonly bffUserService: BffUserService) {}

  logout(): void {
    this.bffUserService.logout();
  }
}
